import React , { useEffect } from 'react';
import '../../cssFiles/aboutus.scss';
import Header from '../layouts/header';
import Footer from '../layouts/footer'; 
import parse from 'html-react-parser';

let communities = [
  {
    image_path: "/images/about-us/about-us_niveza.png",
    count: "4,00,000+",
    desc: "Registered Members"
  },
  {
    image_path: "/images/about-us/about-us_service_gurantee.png",
    count: "14,000+",
    desc: "Paid Subscribers"
  },
  {
    image_path: "/images/about-us/about-us_employee.png",
    count: "80+",
    desc: "Employees"
  }
];


const management = [  
  {
    name: "Praveen Kedar",
    img: "/images/about-us/praveen_kedar.png",
    title: "CEO/Chief Investment Officer",
    desc: `Praveen has 25+ years experience in technology and management with last 20+ years in the United States and has founded and built 3 successful SAAS product companies along with a software engineering services firm.<br/><br/>
        He became interested in equity markets 15+ years ago and soon realized a huge challenge in finding a reliable equity research adviser.. Most brokerage firms are focused only on generating high brokerage by promoting Intra-day, F&O etc. products as a sure shot way to succeed in the market. This only results into clients losing the capital in a short period of time. Rest of the market is flooded with small time stock tips providers who make impossible and unproven claims.<br/>`,     
    last_desc:`Praveen is on a mission to create the most trusted capital research and wealth management firm in the India. He goes above and beyond to ensure that Niveza offers only those products which would create sustainable wealth for our clients.`
  
},
  {
    name: "Sayali Kedar",
    img: "/images/about-us/sayali_kedar.png",
    title: "COO/Director",
    desc: `Sayali has 15+ years of experience in business & technology management. She handles overall operations in the India since last 10+ years. <br/><br/>         
          She has 5+ years of boilerplate experience in financial services industry before joining Niveza. She gained valuable experience in Business Process Re-engineering group while working at a leading private sector bank in India. During her tenure, She was exposed to the most areas of banking like retail assets, retail liabilities, custody services, finance, collection, business banking, risk Intelligence and control etc. <br/>`,
    last_desc:`Sayali is a go-getter and always focused on advancing the cause of subscribers, employees, and overall business. Sayali is very passionate about building Niveza as the most trusted capital research & wealth management firm in India.`
  }
];

const timelineItems =  [ 
  { year: 2012, text: "Launched stock market virtual trading platform used by reputed media houses like Jagran, Sakal, New Indian Express, Sandesh etc." },
  { year: 2014, text: "Launched Premium Equity Research products for short, mid, and long term investing." },
  { year: 2015, text: "SEBI Registered Research Analyst." },
  { year: 2017, text: "Launched Personalised Research Product p360° Premium product with free brokerage and dealer services." },
  { year: 2019, text: "Service Guarantee added to p360° Premium product." },
  { year: 2021, text: "First of a kind in India, Market Heatmap Report launched." },
  { year: 2024, text: "Developed Predictive AI based 360° algorithm to rank & screen Indian equities based on Fundamentals & Technical." },
  { year: 2026, text: "(Coming up) News and Macro sentiment analysis to be incorporated in 360o algorithm to rank & screen India Equities." },
];


const missionStatements = [
  "Promote investing strategies that create sustainable capital growth so everyone has a chance to create wealth and benefit from India's economic success.",
  "Educate investors about capital destruction caused by ultra short term trading (Intraday, BTST, STBT etc.) & highly leveraged trading (F&O, Forex etc.) promoted by brokers and tips providers who are in it for themselves.",
  "We believe in integrity and transparency in all recommendations, continuous research and improvement, and a client-centric approach."
];



const AboutUs = () => {

  useEffect(()=> {
    document.title = "Niveza -  About Us";
  }, []);

  return (
    <div className="aboutus-container">
      <Header/>
      <div className="aboutus-main">

        <div className="aboutus-section aboutus-mission bullet-points">
          <h2>Our Mission</h2>
          {missionStatements.map((statement, idx) => (
            <p key={idx}>{statement}</p>
          ))}
        </div>

        <div className="aboutus-section">
          <h2>Our Community</h2>
          <div className="aboutus-communities">
            {communities.map((community, idx) => (
              <div className="aboutus-community" key={idx}>
                <img src={community.image_path} alt={community.desc} className="aboutus-community-icon" />
                <div className={`aboutus-community-count ${community.desc === 'Employees' ? 'centered' : ''}`}>{community.count}</div>    
                <div className={`aboutus-community-desc ${community.desc === 'Employees' ? 'centered' : ''}`}>{community.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* <div className="aboutus-section aboutus-timeline">
          <h2>Our Timeline</h2>
          <Timeline mode="left">
            {events.map((event, index) => (
              <Timeline.Item
                key={index}
                dot={
                  <div>
                    <div
                      style={{
                        background: "white",
                        border: "1px solid black",
                        color: "black",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        textAlign: "center",
                        width: "50px",
                      }}
                    >
                      {event.year}
                    </div>
                  </div>
                }
              >
                <span>{event.text}</span>
              </Timeline.Item>
            ))}
          </Timeline>
        </div> */}

        <div className="aboutus-section aboutus-timeline">
          <h2>Our Timeline</h2>
          <ul>
            {timelineItems.map(item => ( 
              <li key={item.year}><strong>{item.year}:</strong> {item.text}</li>
            ))}
          </ul>
        </div>





        <div className="aboutus-section aboutus-management">
          <h2>Our Executive Management</h2>
          <div className="aboutus-executives">
            {management.map((person, index) => (
              <>
                {index % 2 === 0 ? (
                  <div  className="aboutus-exec-card" key={index}>
                    <div className="aboutus-exec-photo-desc">
                      <img
                        src={person.img}
                        alt={`${person.name}'s`}
                        className="aboutus-exec-photo"
                      />
                      <div className="aboutus-exec-name">{person.name}</div>
                      <div className="aboutus-exec-title">{person.title}</div>
                    </div>

                    <div className="aboutus-exec-right">
                      <div className="aboutus-exec-desc">{parse(person.desc)}</div>
                    </div>
                  </div>
                ) : (
                  <div className="aboutus-exec-card" key={index}>
                    <div>
                      <div className="aboutus-exec-desc">{parse(person.desc)}</div>
                    </div>

                    <div className="aboutus-exec-photo-desc" >
                      <img
                        src={person.img}
                        alt={`${person.name}'s`}
                        className="aboutus-exec-photo"
                      />
                      <div className="aboutus-exec-name">{person.name}</div>
                      <div className="aboutus-exec-title">{person.title}</div>
                    </div>
                  </div>
                )}

                <div  className="aboutus-exec-desc">{parse(person.last_desc)}</div>
                {index < management.length-1 ? <hr style={{border: '1px solid grey', width: '50%'}} /> : ''}
              </>
            ))}
          </div>
        </div>
        <div className="aboutus-section aboutus-contact">
          <h2>Our Research Desk</h2>
          <div>
            <div className='aboutus-research-desk-images'>
              <img src="/images/about-us/about-us_research_desk1.png" alt="Research Desk" className="aboutus-research-desk" />
              <img src="/images/about-us/about-us_research_desk2.png" alt="Research Desk" className="aboutus-research-desk" />
            </div>
            <div className="aboutus-contact-us">
              <img src="/images/about-us/about-us_teerth.png" alt="Contact Us"  className="aboutus-research-desk"/>          
              <div>
                <strong>Office:</strong> A203, Teerth Technospace, Baner, Pune, 411045 Maharashtra, India<br />
                <strong>Email:</strong> <a href="mailto:support@niveza.in">support@niveza.in</a><br />
                <strong>Phone:</strong> <span className="aboutus-phone">+91-96075-27770</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
};

export default AboutUs;